// helpers/user.js

/**
 * Save user data (like profile info) to localStorage.
 * @param {Object} userData - The user data to save.
 */
export const setUserData = (userData) => {
    localStorage.setItem('user', JSON.stringify(userData));
  };
  
  /**
   * Get user data from localStorage.
   * @returns {Object|null} The user data or null if not found.
   */
  export const getUserData = () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;  // Parse the stored string to an object
  };
  
  /**
   * Remove user data from localStorage (e.g., on logout).
   */
  export const removeUserData = () => {
    localStorage.removeItem('user');
  };
  
  /**
   * Get the user's ID from the stored user data in localStorage.
   * @returns {string|null} The user ID or null if not found.
   */
  export const getUserId = () => {
    const user = getUserData();
    return user ? user.id : null;  // Assuming user has an 'id' field
  };
  
  /**
   * Check if a user is logged in (i.e., if user data exists in localStorage).
   * @returns {boolean} True if the user is logged in, false otherwise.
   */
  export const isUserLoggedIn = () => {
    return getUserData() !== null;
  };
  